module.exports = __webpack_public_path__ + "static/media/call-icon-restaurant.afcb717a.svg";